var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQualityGraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "121px",
    height: "120px",
    viewBox: "0 0 121 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-5.4%",
    y: "-10.9%",
    width: "110.8%",
    height: "121.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 14,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0705882353   0 0 0 0 0.101960784   0 0 0 0 0.192156863  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D\\xE9tail---Facture-produit---Onglet-2",
    transform: "translate(-1115.000000, -491.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card/dashboard-facture-white",
    filter: "url(#filter-1)",
    transform: "translate(448.000000, 202.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illu/graph",
    transform: "translate(680.353846, 289.430769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.7891249,90.4831882 C72.4510969,92.2731242 89.3421377,85.2459119 94.0346631,70.2731962 C98.6352975,55.5914961 89.2032356,37.1148201 74.8718212,30.0219601 C60.5404755,22.9305293 43.288633,26.6841258 32.9684497,37.426053 C27.4633136,43.1563646 23.6653754,50.8497096 23.2817181,59.2618443 C23.093451,63.3846476 23.5500673,69.453481 25.5616512,73.2871427 C26.8768543,75.7913513 28.4431484,78.1986119 30.428769,80.2042724 C33.58373,83.3954981 37.9299111,84.9082745 41.8767895,86.552606 C46.7020303,88.563512 51.7371115,89.9051561 56.7891249,90.4831882",
    id: "Fill-1",
    fill: "#CCE8F6",
    transform: "translate(59.226356, 58.576361) rotate(-210.000000) translate(-59.226356, -58.576361) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "sliders-v",
    fill: "#232323",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.3230769,66.2615385 C52.3710105,66.238533 50.7947512,64.8176117 50.7692308,63.0579186 L50.7692308,33.1574661 C50.7692308,31.3881556 52.3603419,29.9538462 54.3230769,29.9538462 C56.285812,29.9538462 57.8769231,31.3881556 57.8769231,33.1574661 L57.8769231,63.0579186 C57.8514026,64.8176117 56.2751433,66.238533 54.3230769,66.2615385 L54.3230769,66.2615385 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3230769,28.1384615 C52.3710105,28.1151464 50.7947512,26.6750973 50.7692308,24.891716 L50.7692308,3.24674556 C50.7692308,1.4536175 52.3603419,0 54.3230769,0 C56.285812,0 57.8769231,1.4536175 57.8769231,3.24674556 L57.8769231,24.891716 C57.8514026,26.6750973 56.2751433,28.1151464 54.3230769,28.1384615 L54.3230769,28.1384615 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4153846,28.1384615 L46.2,28.1384615 C44.237265,28.1384615 42.6461538,26.7161046 42.6461538,24.9615385 C42.6461538,23.2069723 44.237265,21.7846154 46.2,21.7846154 L60.4153846,21.7846154 C62.3781196,21.7846154 63.9692308,23.2069723 63.9692308,24.9615385 C63.9692308,26.7161046 62.3781196,28.1384615 60.4153846,28.1384615 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64615385,66.2615385 C7.69408745,66.238533 6.11782816,64.8176117 6.09230769,63.0579186 L6.09230769,33.1574661 C6.09230769,31.3881556 7.68341881,29.9538462 9.64615385,29.9538462 C11.6088889,29.9538462 13.2,31.3881556 13.2,33.1574661 L13.2,63.0579186 C13.1744795,64.8176117 11.5982202,66.238533 9.64615385,66.2615385 L9.64615385,66.2615385 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64615385,28.1384615 C7.69408745,28.1151464 6.11782816,26.6750973 6.09230769,24.891716 L6.09230769,3.24674556 C6.09230769,1.4536175 7.68341881,0 9.64615385,0 C11.6088889,0 13.2,1.4536175 13.2,3.24674556 L13.2,24.891716 C13.1744795,26.6750973 11.5982202,28.1151464 9.64615385,28.1384615 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7692308,28.1384615 L3.55384615,28.1384615 C1.59111112,28.1384615 0,26.7161046 0,24.9615385 C0,23.2069723 1.59111112,21.7846154 3.55384615,21.7846154 L17.7692308,21.7846154 C19.7319658,21.7846154 21.3230769,23.2069723 21.3230769,24.9615385 C21.3230769,26.7161046 19.7319658,28.1384615 17.7692308,28.1384615 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,66.2615385 C31.0479336,66.2387247 29.4716743,64.8296444 29.4461538,63.0846154 L29.4461538,50.376923 C29.4461538,48.6223568 31.037265,47.2 33,47.2 C34.962735,47.2 36.5538462,48.6223568 36.5538462,50.376923 L36.5538462,63.0846154 C36.5283257,64.8296444 34.9520664,66.2387247 33,66.2615385 L33,66.2615385 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,44.4769231 C31.0479336,44.4541093 29.4716743,43.045029 29.4461538,41.3 L29.4461538,3.17692295 C29.4461538,1.42235683 31.037265,0 33,0 C34.962735,0 36.5538462,1.42235683 36.5538462,3.17692295 L36.5538462,41.3 C36.5283257,43.045029 34.9520664,44.4541093 33,44.4769231 L33,44.4769231 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0923077,44.4769231 L24.8769231,44.4769231 C22.914188,44.4769231 21.3230769,43.0545662 21.3230769,41.3 C21.3230769,39.5454338 22.914188,38.1230769 24.8769231,38.1230769 L39.0923077,38.1230769 C41.0550427,38.1230769 42.6461538,39.5454338 42.6461538,41.3 C42.6461538,43.0545662 41.0550427,44.4769231 39.0923077,44.4769231 L39.0923077,44.4769231 Z",
    id: "Path"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityGraph);
export default __webpack_public_path__ + "static/media/quality-graph.268475eaf782dadef6c1603c7503ae4a.svg";
export { ForwardRef as ReactComponent };